import Vue from 'vue';
import BootstrapVue from "bootstrap-vue";
import "element-ui/lib/theme-chalk/input-number.css";
import "bootstrap/dist/css/bootstrap.css";
import "vuejs-dialog/dist/vuejs-dialog.min.css";
import store from '@/store'
//import 'bootstrap-vue/dist/bootstrap-vue.css'
import "@/assets/scss/now-ui-kit.scss";
import "@/assets/css/style.css";
import "@/assets/fontello/css/urapppro-icon.css";
import globalDirectives from "./globalDirectives";
import globalMixins from "./globalMixins";
import globalComponents from "./globalComponents";
import "@/assets/css/urapppro-animation.css";
import VueLazyload from "vue-lazyload";
import { Vue2Storage } from "vue2-storage";
import Vue2Filters from "vue2-filters";
import Element from "element-ui";
//import locale from "element-ui/lib/locale/lang/en";
import moment from "moment-timezone";
import SweetAlertIcons from "vue-sweetalert-icons";
import Notifications from "vue-notification";
import velocity from "velocity-animate";
import VuejsDialog from "vuejs-dialog";
import Connector from "./connector";
import SentryExceptionHandler from "./SentryExceptionHandler";
import AppInit from "./appInit";
import VueProgressBar from "vue-progressbar";
import VueScrollTo from "vue-scrollto";
import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
import i18n from '@/i18n'
import VueMeta from 'vue-meta'

Sentry.init({
  Vue: Vue,
  dsn:
    "https://e3908445b8dc4ba8a6cfd188843cc19c@o430882.ingest.sentry.io/5381601",
  environment: process.env.VUE_APP_ENV,
  logErrors: true,
  ignoreErrors: [
    'Non-Error exception captured',
    'Non-Error promise rejection captured',
    'ResizeObserver loop limit exceeded'
  ],
  defaultIntegrations: false,
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  tracingOptions: {
    trackComponents: true,
  },
  denyUrls: [
    // Facebook flakiness
    /graph\.facebook\.com/i,
    // Facebook blocked
    /connect\.facebook\.net\/en_US\/all\.js/i,
    // Chrome extensions
    /extensions\//i,
    /^chrome:\/\//i,

    // google analytics
    /google-analytics\.com/i
  ]
});

Vue.prototype.$moment = moment;
export default {

  install(Vue) {
    moment.tz.setDefault(moment.tz.guess());

    const Vue2FiltersConfig = {
      capitalize: {
        onlyFirstLetter: false,
      },
      currency: {
        symbol: store.state.currentCurrency,
        decimalDigits: 2,
        thousandsSeparator: ",",
        decimalSeparator: ".",
        symbolOnLeft: true,
        spaceBetweenAmountAndSymbol: false,
      },
      pluralize: {
        includeNumber: false,
      },
      ordinal: {
        includeNumber: false,
      },
    };

    Vue.use(Element, {
      i18n: (key, value) => i18n.t(key, value)
    })
    Vue.use(globalDirectives);
    Vue.use(globalMixins);
    Vue.use(globalComponents);
    Vue.use(BootstrapVue);
    Vue.use(Vue2Storage);
    Vue.use(Vue2Filters, Vue2FiltersConfig);
    Vue.use(SweetAlertIcons);
    Vue.use(Notifications, { velocity });
    Vue.use(VuejsDialog);
    Vue.use(Connector);
    Vue.use(SentryExceptionHandler);
    Vue.use(AppInit);
    Vue.use(VueLazyload, {
      observer: true,
      // optional
      observerOptions: {
        rootMargin: "0px",
        threshold: 0.1,
      },
    });
    Vue.use(VueScrollTo);
    Vue.use(VueProgressBar, {
      color: "rgb(143, 255, 199)",
      failedColor: "red",
      height: "2px",
    });
    Vue.use(Sentry);
    Vue.use(VueMeta,{
      keyName: 'head'
    });
  },
};
